import { useEffect, useState, useRef } from 'react';

const isClient = typeof window === 'object';

function useViewport() {
    const [size, setSize] = useState({
        width: isClient ? window.innerWidth : 0,
        height: isClient ? window.innerHeight : 0,
    });

    const throttle = useRef(null);

    useEffect(() => {
        const onResize = () => {
            if (throttle.current) {
                clearTimeout(throttle.current);
            }

            throttle.current = setTimeout(() => {
                setSize({
                    width: isClient ? window.innerWidth : 0,
                    height: isClient ? window.innerHeight : 0,
                });
            }, 500);
        };

        window.addEventListener('resize', onResize);

        return () => {
            window.removeEventListener('resize', onResize);
        };
    }, []);

    return size;
}

export default useViewport;
